import { render, staticRenderFns } from "./videoList.vue?vue&type=template&id=12cf32a1&scoped=true&"
import script from "./videoList.vue?vue&type=script&lang=ts&"
export * from "./videoList.vue?vue&type=script&lang=ts&"
import style0 from "./videoList.vue?vue&type=style&index=0&id=12cf32a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cf32a1",
  null
  
)

export default component.exports